// extracted by mini-css-extract-plugin
export var loadingSpinner = "_65-1";
export var standaloneTable = "_65-0";